import { render, staticRenderFns } from "./BodyGames.vue?vue&type=template&id=70818d14&scoped=true"
import script from "./BodyGames.vue?vue&type=script&lang=js"
export * from "./BodyGames.vue?vue&type=script&lang=js"
import style0 from "./BodyGames.vue?vue&type=style&index=0&id=70818d14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70818d14",
  null
  
)

export default component.exports